import React from 'react';
import PasswordProtected from '../PasswordProtected';

const RecipeContent = () => {
  return (
    <div className="min-h-screen bg-[url('/src/waves-desktop.svg')] bg-cover bg-center bg-no-repeat">
      {/* Header */}
      <div className="bg-white/90 backdrop-blur-sm shadow-sm">
        <div className="max-w-6xl mx-auto px-4 tablet:px-6 py-6 tablet:py-8">
          <h1 className="text-2xl tablet:text-3xl desktop:text-4xl font-bold text-gray-900 mb-4">
            crispy pork belly bao with brian, jmen, and vik
          </h1>
          <p className="text-base tablet:text-lg text-gray-600 leading-relaxed">
            welcome brian, jmen, and vik! today we will be making crispy pork belly bao sponsored by a random recipe i found online. please report to my kitchen no later than tuesday, february 17th at 4pm.
          </p>
        </div>
      </div>

    {/* Recipe Info Section */}
        <div className="max-w-6xl mx-auto px-4 tablet:px-6 py-6 tablet:py-8">
          <div className="bg-white/90 backdrop-blur-sm rounded-lg shadow-md p-4 tablet:p-6 mb-6 tablet:mb-8">
            <h2 className="text-xl tablet:text-2xl font-semibold text-gray-900 mb-4"></h2>
            <div className="grid grid-cols-2 laptop:grid-cols-4 gap-3 tablet:gap-4 text-center">
            <div className="bg-blue-50 p-3 tablet:p-4 rounded-lg flex flex-col justify-center">
              <div className="text-lg tablet:text-xl desktop:text-2xl font-bold text-blue-900">
                <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">chef lazy bribri</span>
                </li>
                <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">chef jmen</span>
                </li>
                <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">chef vik</span>
                </li>
                </div>
              <div className="text-xs tablet:text-sm text-gray-600">Chefs in Session</div>
            </div>
            <div className="bg-teal-50 p-3 tablet:p-4 rounded-lg flex flex-col justify-center">
              <div className="text-lg tablet:text-xl desktop:text-2xl font-bold text-teal-400">1h 5min</div>
              <div className="text-xs tablet:text-sm text-gray-600">Total Time</div>
            </div>
            <div className="bg-green-50 p-3 tablet:p-4 rounded-lg flex flex-col justify-center">
              <div className="text-lg tablet:text-xl desktop:text-2xl font-bold text-green-600">4</div>
              <div className="text-xs tablet:text-sm text-gray-600">Servings</div>
            </div>
            <div className="bg-red-50 p-3 tablet:p-4 rounded-lg flex flex-col justify-center">
              <div className="text-lg tablet:text-xl desktop:text-2xl font-bold text-red-600">easy af, just read instructions</div>
              <div className="text-xs tablet:text-sm text-gray-600">Difficulty</div>
            </div>
            </div>
          </div>

          {/* Ingredients and Instructions Side by Side */}
          <div className="grid grid-cols-1 laptop:grid-cols-2 gap-6">
            {/* Ingredients */}
            <div className="bg-white/95 backdrop-blur-sm rounded-lg shadow-md p-4 tablet:p-6">
              <h2 className="text-xl tablet:text-2xl font-semibold text-gray-900 mb-4 tablet:mb-6">Ingredients</h2>

              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">Pork Belly:</h3>
                  <ul className="space-y-1 text-gray-700">
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Pork belly, skin on</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">1 lb</span>
                    </li>
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Salt (for skin prep)</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">1 Tbsp</span>
                    </li>
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Salt (for seasoning meat)</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">1 tsp</span>
                    </li>
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Black pepper</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">1 tsp</span>
                    </li>
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Five-spice powder</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">1 tsp</span>
                    </li>
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Chicken bouillon</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">1 tsp</span>
                    </li>
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Rice or white vinegar</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">1 Tbsp</span>
                    </li>
                  </ul>

                  <h3 className="font-semibold text-lg text-gray-800 mb-2 mt-4">Bao Assembly:</h3>
                  <ul className="space-y-1 text-gray-700">
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Frozen steamed buns</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">1 package</span>
                    </li>
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Carrot, julienned</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">1</span>
                    </li>
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Cilantro</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">1 small bunch</span>
                    </li>
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Hoisin sauce</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">to taste</span>
                    </li>
                    <li className="flex justify-between items-start">
                      <span className="flex-1 pr-2">• Crushed peanuts (optional)</span>
                      <span className="text-gray-500 text-sm flex-shrink-0">to taste</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-8 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                  <h4 className="font-semibold text-yellow-800 mb-2">Tips:</h4>
                  <ul className="text-sm text-yellow-700 space-y-1">
                    <li>• leave pork belly uncovered in fridge for minimum 2 hours (overnight preferred) to dry the skin for maximum crispiness</li>
                    <li>• score the skin in a crisscross pattern without cutting into the meat</li>
                    <li>• only season the meat side, not the skin side</li>
                    <li>• let pork belly rest for 10 minutes before slicing</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Instructions */}
            <div className="bg-white/95 backdrop-blur-sm rounded-lg shadow-md p-4 tablet:p-6">
              <h2 className="text-xl tablet:text-2xl font-semibold text-gray-900 mb-4 tablet:mb-6">Instructions</h2>

              <div className="space-y-6">
                <div>
                  <h3 className="font-semibold text-lg text-gray-800 mb-3">Pork Belly Preparation:</h3>
                  <ol className="space-y-3 text-gray-700">
                    <li className="flex">
                      <span className="bg-teal-300 text-white rounded-md w-6 h-6 flex items-center justify-center text-xs tablet:text-sm mr-2 tablet:mr-3 mt-0.5 flex-shrink-0">1</span>
                      <span className="text-sm tablet:text-base">Pat pork belly dry with paper towels. Score the skin in a crisscross pattern without cutting into the meat.</span>
                    </li>
                    <li className="flex">
                      <span className="bg-teal-300 text-white rounded-md w-6 h-6 flex items-center justify-center text-xs tablet:text-sm mr-2 tablet:mr-3 mt-0.5 flex-shrink-0">2</span>
                      <span className="text-sm tablet:text-base">Brush the skin side with vinegar and rub thoroughly with 1 tablespoon of salt.</span>
                    </li>
                    <li className="flex">
                      <span className="bg-teal-300 text-white rounded-md w-6 h-6 flex items-center justify-center text-xs tablet:text-sm mr-2 tablet:mr-3 mt-0.5 flex-shrink-0">3</span>
                      <span className="text-sm tablet:text-base">Place uncovered in the fridge for a minimum of 2 hours (overnight preferred) to dry out the skin.</span>
                    </li>
                    <li className="flex">
                      <span className="bg-teal-300 text-white rounded-md w-6 h-6 flex items-center justify-center text-xs tablet:text-sm mr-2 tablet:mr-3 mt-0.5 flex-shrink-0">4</span>
                      <span className="text-sm tablet:text-base">Season the meat side only with 1 tsp salt, pepper, five-spice powder, and chicken bouillon.</span>
                    </li>
                    <li className="flex">
                      <span className="bg-teal-300 text-white rounded-md w-6 h-6 flex items-center justify-center text-xs tablet:text-sm mr-2 tablet:mr-3 mt-0.5 flex-shrink-0">5</span>
                      <span className="text-sm tablet:text-base">Preheat air fryer to 325°F. Place pork belly skin-side up and cook for 45-50 minutes until golden. Increase temperature to 400°F for the final 6-7 minutes for extra crispiness.</span>
                    </li>
                  </ol>
                </div>

                <div>
                  <h3 className="font-semibold text-lg text-gray-800 mb-3">Bao Assembly:</h3>
                  <ol className="space-y-3 text-gray-700">
                    <li className="flex">
                      <span className="bg-teal-300 text-white rounded-md w-6 h-6 flex items-center justify-center text-xs tablet:text-sm mr-2 tablet:mr-3 mt-0.5 flex-shrink-0">1</span>
                      <span className="text-sm tablet:text-base">Steam the frozen buns according to package directions.</span>
                    </li>
                    <li className="flex">
                      <span className="bg-teal-300 text-white rounded-md w-6 h-6 flex items-center justify-center text-xs tablet:text-sm mr-2 tablet:mr-3 mt-0.5 flex-shrink-0">2</span>
                      <span className="text-sm tablet:text-base">Let the pork belly rest for 10 minutes, then slice into bite-sized pieces.</span>
                    </li>
                    <li className="flex">
                      <span className="bg-teal-300 text-white rounded-md w-6 h-6 flex items-center justify-center text-xs tablet:text-sm mr-2 tablet:mr-3 mt-0.5 flex-shrink-0">3</span>
                      <span className="text-sm tablet:text-base">Fill each bun with pork belly slices, julienned carrot, cilantro, hoisin sauce, and crushed peanuts if desired.</span>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

      </div>
    </div>
  );
};

const RecipePage = () => {
  return (
    <PasswordProtected correctPassword="baobaobao">
      <RecipeContent />
    </PasswordProtected>
  );
};

export default RecipePage;